var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-tags"},_vm._l((_vm.getTagsList),function(tag,key){return _c('p',{directives:[{name:"show",rawName:"v-show",value:(tag),expression:"tag"}],key:`tag${key}`,staticClass:"news-header__rubric",on:{"click":function($event){return _vm.setTag(tag)}}},[_vm._v(" "+_vm._s(tag.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }